import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useContractStore = create()(
    persist(
        (set) => ({
            refetchContracts: false,
            storeRefetchContracts: (refetchContracts) => set(() => ({ refetchContracts: refetchContracts })),
            query: getInitialQuery(),
            storeQuery: (query) => set(() => ({ query: query }))
        }),
        {
            name: 'contract-storage'
        }
    )
);

export default useContractStore;